// extracted by mini-css-extract-plugin
export var captionTitle = "SectionMultipleImages-module--caption-title--6f9b7";
export var heading = "SectionMultipleImages-module--heading--9bcfd";
export var imageCaption = "SectionMultipleImages-module--image-caption--d2ad2";
export var imageTable = "SectionMultipleImages-module--imageTable--a46b8";
export var media = "SectionMultipleImages-module--media--a1b2d";
export var multipleImagesContainer = "SectionMultipleImages-module--multipleImagesContainer--789f6";
export var subHeading = "SectionMultipleImages-module--subHeading--9a8ce";